import React from "react";
import HomePage from "./views/HomePage";
import ReuseableComponents from "./views/ReuseableComponents";
import Navbar from "./components/nav/Navbar";
import Listings from "./views/Listings";
import { Switch, Route } from "react-router-dom";
import ProductPage from "./views/ProductPage";
import Seller from "./views/Seller";
import SellerList from "./views/SellerList";
import AboutUs from "./views/AboutUs";
import ProMachinery from "./views/ProMachinery";
import SellWithUs from "./views/SellWithUs";
import ContactUs from "./views/ContactUs";
import AuctionListing from "./views/AuctionListing";
import AuctionPage from "./views/AuctionPage";
function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={HomePage} />
      <Route path="/components" component={ReuseableComponents} />
      <Route path="/nav" component={Navbar} />
      <Route path="/listings/:login" component={Listings} />
      <Route path="/plp/:login" component={ProductPage} />
      <Route path="/seller" component={Seller} />
      <Route path="/seller-list" component={SellerList} />
      <Route path="/aboutus" component={AboutUs} />
      <Route path="/pro-machinery" component={ProMachinery} />
      <Route path="/sell-with-us" component={SellWithUs} />
      <Route path="/contact-us" component={ContactUs} />
      <Route path="/auction/:login" component={AuctionListing} />
      <Route path="/auction-page" component={AuctionPage} />
      <Route path="/exhibition-page" component={AuctionPage} />
    </Switch>
  );
}

export default Routes;
